export default "__VITE_ASSET__BXppgID0__"